/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiUserProfile } from './UserProfile';
import { ApiMembership } from './Membership';
import { ApiFreeTrial } from './FreeTrial';
import { ApiFollowedTopic } from './FollowedTopic';
import { ApiUserOmniauth } from './UserOmniauth';
import { ApiAffiliate } from './Affiliate';

export interface UserRequest {

    /**
     * User or Guest
     */
    type?: string;

    /**
     * User ID
     */
    id?: number;

    uuid?: string;

    wp_user?: string;

    /**
     * User's email address
     */
    email?: string;

    /**
     * Username for the user
     */
    username?: string;

    display_name?: string;

    /**
     * User's profile
     */
    profile?: ApiUserProfile;

    membership?: ApiMembership;

    /**
     * True if member is entitled
     */
    in_good_standing?: string;

    disabled?: boolean;

    confirmed?: string;

    admin?: string;

    /**
     * True if a user is a staff member
     */
    staff?: boolean;

    super_admin?: string;

    created_at?: string;

    /**
     * Trials Taken
     */
    trials?: ApiFreeTrial;

    topics?: ApiFollowedTopic[];

    premium?: boolean;

    entitled?: boolean;

    missing_password?: boolean;

    /**
     * When true the user is prevented from reporting content for moderation
     */
    disable_reporting?: boolean;

    /**
     * Date until the user is prevented from reporting content for moderation
     */
    disable_reporting_until?: string;

    /**
     * When true the user is prevented from posting comments on content
     */
    disable_commenting?: boolean;

    /**
     * Date until the user is prevented from posting comments on content
     */
    disable_commenting_until?: string;

    rstatus?: string;

    omniauths?: ApiUserOmniauth[];

    /**
     * Affiliate user
     */
    affiliate?: ApiAffiliate;

}

@Model('User')
export class ApiUser extends BaseModel implements UserRequest {

    /**
     * User or Guest
     */
    
    
    type: string;

    /**
     * User ID
     */
    
    
    id: number;

    
    
    uuid: string;

    
    
    wp_user: string;

    /**
     * User's email address
     */
    
    
    email: string;

    /**
     * Username for the user
     */
    
    
    username: string;

    
    
    display_name: string;

    /**
     * User's profile
     */
    @Type('ApiUserProfile')
    @Expand()
    profile: ApiUserProfile;

    @Type('ApiMembership')
    @Expand()
    membership: ApiMembership;

    /**
     * True if member is entitled
     */
    
    
    in_good_standing: string;

    
    
    disabled: boolean;

    
    
    confirmed: string;

    
    
    admin: string;

    /**
     * True if a user is a staff member
     */
    
    
    staff: boolean;

    
    
    super_admin: string;

    
    
    created_at: string;

    /**
     * Trials Taken
     */
    @Type('ApiFreeTrial')
    @Expand()
    trials: ApiFreeTrial;

    @Type('ApiFollowedTopic')
    @Expand()
    topics: ApiFollowedTopic[];

    
    
    premium: boolean;

    
    
    entitled: boolean;

    
    
    missing_password: boolean;

    /**
     * When true the user is prevented from reporting content for moderation
     */
    
    
    disable_reporting: boolean;

    /**
     * Date until the user is prevented from reporting content for moderation
     */
    
    
    disable_reporting_until: string;

    /**
     * When true the user is prevented from posting comments on content
     */
    
    
    disable_commenting: boolean;

    /**
     * Date until the user is prevented from posting comments on content
     */
    
    
    disable_commenting_until: string;

    
    
    rstatus: string;

    @Type('ApiUserOmniauth')
    @Expand()
    omniauths: ApiUserOmniauth[];

    /**
     * Affiliate user
     */
    @Type('ApiAffiliate')
    @Expand()
    affiliate: ApiAffiliate;

}
